// extracted by mini-css-extract-plugin
export default {"root":"Editor_root__fewbQ","readOnly":"Editor_readOnly__yavxq","hidden":"Editor_hidden__9CwtS"};